import { render } from "./SignUp.vue?vue&type=template&id=a3c1fbc2"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"

import "./SignUp.vue?vue&type=style&index=0&id=a3c1fbc2&lang=css"
script.render = render

export default script